export const toUnixTimestamp = (date: Date | string = ''): number | null => {
    const timestamp = Math.floor(new Date(date).getTime() / 1000);

    return isNaN(timestamp) ? null : timestamp;
};
